import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchExpenseCategoryList = ({commit}, payload) => {

    axios.post('/expenseCategory/index.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setExpenseCategoryList', {response: res.data.response, total: res.data.total, page_number: res.data.page_number, page_number: res.data.page_number})
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchExpenseSubCategoryList = ({commit}) => {

    axios.get('/expenseCategory/allSubCategory.php', accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        commit('setExpenseCategoryList', {response: res.data.response, total: 0})         
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchExpenseCategoryData = ({commit}, payload) => {
    commit('toggleLoadingState', true)
    axios.post('/expenseCategory/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            if(payload.copy) {
                res.data.response.id = 0
                commit('displaySuccessNotification', {message: 'Data copied!!!'});                
            }
            
            commit('setExpenseCategoryData', {response: res.data.response, copy: payload.copy})   
            if(payload.navigate) {
                router.push(router.currentRoute.fullPath+'/form/')
            }

        } else {
            commit('resetExpenseCategoryData')
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitExpenseCategoryData = ({commit}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/expenseCategory/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            //if(payload.id === 0) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            //}
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteExpenseCategoryData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/expenseCategory/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else {
                dispatch('fetchExpenseCategoryList')
            }
            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/expenseCategory/actions.js